import styled, { css } from 'styled-components';

export const Container = styled.div`
    background-color: ${p => p.theme.mode === "dark" ? p.theme.c.snow : p.theme.c.greyE};
    margin-top: 25px;
    padding-top: 25px;
    padding-bottom: 56px;
    position: relative;

    &:before {
        content: "";
        height: 25px;
        background-color: ${p => p.theme.c.info};
        width: 100%;
        position: absolute;
        top: -25px;
        left: 0;
    }
    h2 {
        font-size: 40px;
        font-variant: small-caps;
        padding: 0 16px;
        margin-top: 24px;
    }
    h2, p {
        text-align: center;
    }
    p {
        font-size: 24px;
        font-weight: 300;
        margin: auto;
        padding: 0 0 12px;
        line-height: 1.5;
        ${p => p.theme.md.min(css`
            width: 850px;
        `)}



        ${p => p.theme.sm.max(css`
            padding: 0 16px;
            font-size: 18px;
            text-align: justify;
        `)}
        ${p => p.theme.sm.only(css`
            text-align: center;
        `)}
        ${p => p.theme.md.only(css`
            font-size: 20px;
        `)}
    }
`;

export const AppLogo = styled.img`
    border-radius: 24px;
    height: 120px;
    width: 120px;
    margin: auto;
    margin-top: 24px;
    display: block;
    box-shadow: 1px 1px 10px 0 ${p => p.theme.c.boost};
`;

export const Section = styled.div`
    display: flex;
    justify-content: center;
    ${p => p.theme.xs(css`
        flex-wrap: wrap;
    `)}
`;

export const Features = styled.div`
    margin: 32px 0;
`;

export const Feature = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 260px;
    text-align: center;
    margin: 16px;
    position: relative;
    ${p => p.theme.xs(css`
        width: 100%;
    `)}
`;

export const IconWrapper = styled.div`
    span {
        font-size: 56px;
        color: white;
    }

    padding: 12px;
    border-radius: 100px;
    background-color: ${p => p.theme.c.active};
    margin: 12px;
`;

export const FeatureTitle = styled.div`
    font-variant: small-caps;
    font-size: 24px;
    color: ${p => p.theme.c.boost};
    font-weight: 600;
    margin-bottom: 4px;
    ${p => p.theme.sm.max(css`
        font-size: 20px;
    `)}
`;

export const FeatureDescription = styled.div`
    font-weight: 300;
    font-size: 18px;
    ${p => p.theme.sm.max(css`
        font-size: 18px;
    `)}
`;

const Connector = styled.div`
    background-color: ${p => p.theme.c.active};
    height: 2px;
    width: 160px;
    position: absolute;
    top: 56px;
    ${p => p.theme.sm.only(css`
        width: 130px;
    `)}
    ${p => p.theme.xs(css`
        display: none;
    `)}
`;

export const Connector1 = styled(Connector)`
    left: -96px;
    ${p => p.theme.sm.only(css`
        left: -82px;
    `)}
`;

export const Connector2 = styled(Connector)`
    right: -96px;
    ${p => p.theme.sm.only(css`
        right: -82px;
    `)}
`;
